import { toast } from "@ocean/ui-kit/Snackbar"
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query"

import { getApiErrorMessage } from "../utils/getApiErrorMessage"

interface ErrorDisplayMeta {
  /** Auto-show a toast for this query/mutation's error. Defaults to true; pass false to handle the error inline. */
  showError?: boolean
}

declare module "@tanstack/react-query" {
  interface Register {
    queryMeta: ErrorDisplayMeta
    mutationMeta: ErrorDisplayMeta
  }
}

function shouldShowError(meta: ErrorDisplayMeta | undefined): boolean {
  return meta?.showError ?? true
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (shouldShowError(query.meta)) toast.error(getApiErrorMessage(error))
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _onMutateResult, mutation) => {
        if (shouldShowError(mutation.meta)) toast.error(getApiErrorMessage(error))
      },
    }),
  })
}
